<div
  class="border-b border-ui-separator flex items-center md:justify-start overflow-x-auto hide-scrollbar"
  [ngClass]="{
    'justify-between': smallScreensSpaceBetween
  }"
>
  @for (item of sections; track item) {
    <a
      class="tab-item {{ extraTabItemClass }}"
      [ngStyle]="{ minWidth: item.minWidth ? item.minWidth + 'px' : 'auto' }"
      [ngClass]="{
        'tab-item-active': selectedSection === item.key
      }"
      (click)="selectedSectionChanged.emit(item.key)"
    >
      @if (item.icon) {
        <div
          class="tab-icon"
          [ngClass]="{
            '!hidden md:!block': item.showIconMedia === 'desktop',
            'md:!hidden': item.showIconMedia === 'mobile'
          }"
        >
          <svg-icon [key]="item.icon" class="!text-sm"></svg-icon>
        </div>
      }
      <span [ngClass]="{ 'hidden md:block': item.smallScreensTitle }">{{ item.title }}</span>
      @if (item.smallScreensTitle) {
        <span class="md:hidden">{{ item.smallScreensTitle }}</span>
      }
    </a>
  }
</div>
